import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusIntakeCheck.tsx
const IconApplicationStatusIntakeCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M17.5 3.334v1.667h-.833l-4.167 6.25v7.083l-5-2.084V11.25l-4.167-6.25H2.5V3.334zM5.337 5.001l3.83 5.745v5.922l-.21-5.418z"
	})]
});
var IconApplicationStatusIntakeCheck_default = forwardRef(IconApplicationStatusIntakeCheck);
//#endregion
export { IconApplicationStatusIntakeCheck_default as default };
